// extracted by mini-css-extract-plugin
export var actions = "_mo-5";
export var assistantBubble = "_mo-3";
export var assistantRow = "_mo-6";
export var bubble = "_mo-0";
export var humanAvatar = "_mo-4";
export var inlineToolCard = "_mo-1";
export var userBubble = "_mo-2";